module.exports = __webpack_public_path__ + "static/cashback-be3e8ab0f3b8cb8ecfdba4f3b130bccb.png";